import { useRef } from "react";
import { useTransform, useScroll, useSpring } from "framer-motion";
import { Box } from "@chakra-ui/react";
import { MotionGrid as Grid, appearBelow } from "utils/motion";
import Text from "components/base/Text";
import Image from "components/base/Image";
import Container from "components/base/Container";

const height = ["200px", "300px", "300px", "460px"];

export default function TextImageColumns2({
  topTitle,
  topSubtitle,
  topDescription,
  topImage,
  bottomTitle,
  bottomDescription,
  bottomImage,
  isInverted,
  animationId,
  bg,
  ...props
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["-100%", "100%"],
  });
  const springScroll = useSpring(scrollYProgress, {
    stiffness: 176,
    damping: 26,
  });
  const y = useTransform(springScroll, [0, 1], ["0px", "-50px"]);

  return (
    <Box
      ref={ref}
      width="100%"
      bg={bg || (isInverted ? "black.700" : "white")}
      mt="-1px"
    >
      <Container centerContent {...props} pb={0} pt={[12, 18]}>
        <Grid
          style={{ y }}
          variants={appearBelow}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
          width="100%"
          templateColumns={["1fr", null, "1fr 0.75fr"]}
          alignItems="center"
          gap={8}
          mb={[12, null, 20]}
        >
          <Box id={`box-${animationId}`} position="relative" minHeight={height}>
            {topImage && (
              <Image
                src={topImage}
                minHeight={height}
                minWidth={["100%", "320px"]}
                objectFit="contain"
              />
            )}
          </Box>
          <Box p={[0, null, 2, 12]}>
            <Text type="title_lg" color={isInverted ? "white" : "black.900"}>
              {topTitle}
            </Text>
            <Text type="title_xs" color="primary" mb={6}>
              {topSubtitle}
            </Text>
            <Text type="p_md" color={isInverted ? "white" : "black.900"}>
              {topDescription}
            </Text>
          </Box>
        </Grid>
        {(bottomTitle || bottomDescription) && bottomImage && (
          <Grid
            style={{ y }}
            variants={appearBelow}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
            width="100%"
            templateColumns={["1fr", null, "0.75fr 1fr"]}
            alignItems="center"
            gap={8}
            pb={[12, 12, 0]}
          >
            <Box>
              {bottomTitle && (
                <Text
                  type="title_lg"
                  mb="4"
                  color={isInverted ? "white" : "black.900"}
                >
                  {bottomTitle}
                </Text>
              )}
              <Text type="p_md" color={isInverted ? "white" : "black.900"}>
                {bottomDescription}
              </Text>
            </Box>
            <Box order={[-1, null, 1]} position="relative" minHeight={height}>
              <Image
                src={bottomImage}
                minHeight={height}
                minWidth={["100%", "320px"]}
                objectFit="cover"
              />
            </Box>
          </Grid>
        )}
      </Container>
    </Box>
  );
}
